var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrac27020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27020",
    "data-name": "Trac\\xE9 27020",
    d: "M19.33,34h9.34M24,6V8m12.73,3.27-1.42,1.42M42,24H40M8,24H6m6.69-11.31-1.42-1.42m5.66,19.8a10,10,0,1,1,14.14,0l-1.09,1.1A6.719,6.719,0,0,0,28,36.94V38a4,4,0,0,1-8,0V36.94a6.719,6.719,0,0,0-1.98-4.77Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrac27020);
export default __webpack_public_path__ + "static/media/Tracé 27020.23fd88119a6612e83242cdc4c41a5368.svg";
export { ForwardRef as ReactComponent };